module.exports = __webpack_public_path__ + "img/iterm.e5c4b4ec.png";